
export const kNavigationCubeSize = 30;

export const kBorderSize = 1.5;
export const kBorderPosition = 14.5;

export const kLabelPosition = kNavigationCubeSize / 2 + 1;

export const kButtonPosition = 11.5;
export const kButtonSmallSize = 8;
export const kButtonLargeSize = 16;
